// @ts-ignore
import type {StrapiUser} from "@nuxtjs/strapi/dist/runtime/types";
import type UserLocal from "~/libs/interfaces/UserLocal";
import gameUserLocalFactory from "~/libs/factories/GameUserLocalFactory";

const userLocalFactory = {
  createUserFromStrapi(user?: StrapiUser): UserLocal | undefined {
    if (!user) {
      return undefined;
    }

    return {
      id: user.id,
      documentId: user.documentId,

      createdAt: user.createdAt ? new Date(user.createdAt) : undefined,
      updatedAt: user.updatedAt ? new Date(user.updatedAt) : undefined,

      username: user.username,
      email: user.email,
      name: user.name,
      surname: user.surname,

      confirmed: user.confirmed,
      blocked: user.blocked,
      provider: user.provider,

      psc: user.psc,
      hasAgeConsent: user.hasAgeConsent || false,
      consentDatetime: user.consentDatetime ? new Date(user.consentDatetime) : undefined,
      hasRulesConsent: user.hasRulesConsent || false,
      rulesConsentDatetime: user.rulesConsentDatetime ? new Date(user.rulesConsentDatetime) : undefined,

      gameUsers: user.game_users?.map(gameUserLocalFactory.createGameUserFromStrapi),
    }
  }
}
export default userLocalFactory